import { atom } from "recoil";
import { ISearchParams } from "types/common.d";

export const searchParamsState = atom({
  key: "searchParamState",
  default: null as ISearchParams | null,
});
